module.exports = __webpack_public_path__ + "static/media/icn-blazer.cef58668.svg";